import { cva, type VariantProps } from 'class-variance-authority';
import { Button } from '../ui/button';
import { LordIcon } from '../ui/lord-icon';
import { cn } from '@/shared/lib/utils';
import { BellIcon, ChevronLeftIcon } from 'lucide-react';
import type { ComponentProps } from 'react';

const navbarVariants = cva(
  'fixed top-0 left-0 right-0 z-20 bg-white w-full flex items-center h-16',
  {
    variants: {
      variant: {
        none: 'fixed top-0 left-0 right-0 z-20 bg-white w-full flex items-center justify-center h-16',
        home: 'fixed top-0 left-0 right-0 z-20 bg-white w-full flex items-center justify-center h-16',
        notification:
          'fixed top-0 left-0 right-0 z-20 bg-white w-full flex items-center justify-center h-16',
        search:
          'fixed top-0 left-0 right-0 z-20 bg-white w-full flex items-center justify-center h-16',
      },
      size: {
        default: 'h-16 px-5',
        sm: 'h-16 px-3',
        lg: 'h-16 px-6',
        icon: 'h-16',
      },
    },
    defaultVariants: {
      variant: 'none',
      size: 'default',
    },
  }
);

export type NavbarProps = VariantProps<typeof navbarVariants> &
  ComponentProps<'div'> & {
    children?: React.ReactNode;
    onBack?: () => void;

    onAction?: () => void;
  };

export function Navbar({ onBack, children, variant, onAction, className, ...props }: NavbarProps) {
  return (
    <div className={cn(navbarVariants({ variant }), className)} {...props}>
      {onBack && (
        <div className="absolute left-0 pl-5 flex items-center h-full">
          <Button variant="icon" size="icon" className="bg-peach-blossom rounded-lg" onClick={onBack}>
            <ChevronLeftIcon className="size-4 stroke-1" />
          </Button>
        </div>
      )}

      {children}

      {onAction && variant !== 'none' && (
        <div className="absolute right-0 pr-5 flex items-center h-full z-20">
          <Button
            variant="icon"
            size="icon"
            className="bg-night hover:bg-night/90"
            onClick={onAction}
          >
            {variant === 'notification' && <BellIcon className="size-4 text-white stroke-1" />}
            {variant === 'home' && (
              <LordIcon
                src="/lordicons/home.json"
                trigger="click"
                colors="primary:#ffffff"
                className="size-4 flex items-center justify-center"
              />
            )}
            {variant === 'search' && (
              <LordIcon
                src="/lordicons/search.json"
                trigger="click"
                colors="primary:#ffffff"
                className="size-4 flex items-center justify-center"
              />
            )}
          </Button>
        </div>
      )}
    </div>
  );
}
